import React from 'react';
import AeroplaneList from './AeroplaneList'; // The component created above

const MainComponent = () => (
  <div>
    <AeroplaneList />
  </div>
);

export default MainComponent;
